import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import TableRoutingInfo from '../components/setting/TableRoutingInfo'
import { fetchVersion, fetchRoutingInfoIfNeeded } from '../actions/actionsApi'

export default function ContRoutingInfo() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onOpenModal(context) {
    fetchVersion(dispatch);
    fetchRoutingInfoIfNeeded(dispatch, globalstate, context);
  }

  return (<TableRoutingInfo
    settings={globalstate.settings}
    routingResp={globalstate.routingResponse.routingResp}
    versionResp={globalstate.versionResponse.versionResp}
    dataContext={globalstate.testCriteria.context}
    onOpenModal={onOpenModal}
  />);
}
